/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Card_Disabled_TooltipInputs */



/**
* | output |
* | --- |
* | "Cancel your current subscription first to switch to Gateway." |
*
* @param {Gateway_Card_Disabled_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_card_disabled_tooltip = /** @type {((inputs?: Gateway_Card_Disabled_TooltipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Card_Disabled_TooltipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kündigen Sie zuerst Ihr aktuelles Abonnement, um zu Gateway zu wechseln.")
	return /** @type {LocalizedString} */ ("Cancel your current subscription first to switch to Gateway.")
});